var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.091,
    height: 18.143,
    viewBox: "0 0 23.091 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.032,5.625H4.559a2.272,2.272,0,0,0-2.3,2.268L2.25,21.5a2.28,2.28,0,0,0,2.309,2.268H23.032A2.28,2.28,0,0,0,25.341,21.5V7.893A2.28,2.28,0,0,0,23.032,5.625Zm0,15.875H4.559V14.7H23.032Zm0-11.339H4.559V7.893H23.032Z",
    transform: "translate(-2.25 -5.625)",
    fill: "#124395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEc);
export default __webpack_public_path__ + "static/media/icon-ec.6a3fdb5776db7bc6625ce7ecb7a79d53.svg";
export { ForwardRef as ReactComponent };